// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import {
  MUST_BE_NUMERICAL_VALUE,
  REQUIRED,
} from 'errors'

import { stringIsNumber } from 'validators/common'
import validateModulationPowerRange from './validateModulationPowerRange'

const validateRadioModulations = (modulations, error) => {
  error.modulations = []
  modulations.forEach(m => {
    if (!m.enabled) {
      // if it's not enabled, no need to run validation on it.
      error.modulations.push({})
    } else if (m.power === undefined || !m.power.length) {
      // required value if it's enabled
      error.modulations.push({ power: REQUIRED })
    } else if (!stringIsNumber(m.power)) {
      error.modulations.push({ power: MUST_BE_NUMERICAL_VALUE })
    } else {
      validateModulationPowerRange(m, error)
    }
  })
}

export default validateRadioModulations
